var render = function render(){var _vm=this,_c=_vm._self._c;return _c('media-object',_vm._b({scopedSlots:_vm._u([{key:"after",fn:function(){return [([_vm.$options.modes.LIVE, _vm.$options.modes.POST].includes(_vm.mode))?_c('StatusBadge',{attrs:{"value":_vm.value.status,"type":"location"}}):_vm._e()]},proxy:true}])},'media-object',_vm.itemProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }